const DEFAULT_TOSS_START_AT = "2026-04-01T00:00:00+09:00";

function getKoreaDateString(date: Date): string {
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const parts = formatter.formatToParts(date);
  const year = parts.find((part) => part.type === "year")?.value ?? "0000";
  const month = parts.find((part) => part.type === "month")?.value ?? "01";
  const day = parts.find((part) => part.type === "day")?.value ?? "01";

  return `${year}-${month}-${day}`;
}

export function getTossCutoffInstant(): Date {
  const rawValue =
    process.env.REACT_APP_PAYMENT_TOSS_START_AT ?? DEFAULT_TOSS_START_AT;
  const parsed = new Date(rawValue);

  if (Number.isNaN(parsed.getTime())) {
    return new Date(DEFAULT_TOSS_START_AT);
  }

  return parsed;
}

export function isKoreaDateOnOrAfterCutoff(now: Date): boolean {
  return (
    getKoreaDateString(now) >= getKoreaDateString(getTossCutoffInstant())
  );
}

export function isPackPickupUsingToss(pickupStart: Date): boolean {
  return pickupStart.getTime() >= getTossCutoffInstant().getTime();
}
